import { render, staticRenderFns } from "./AdditionalExam.vue?vue&type=template&id=08cd73d2"
import script from "./AdditionalExam.vue?vue&type=script&lang=js"
export * from "./AdditionalExam.vue?vue&type=script&lang=js"
import style0 from "./AdditionalExam.vue?vue&type=style&index=0&id=08cd73d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports